<div class="notification__rich-text-wrapper">
  <pp-rich-text
    class="notification__comment"
    [ppValue]="{
      richText: richText,
      plainText: plainText,
    }"
    [ppCanEdit]="false"
    [ppRichTextOptions]="richTextOptions"
  ></pp-rich-text>

  <div class="notification__respond--desktop notification__respond notification__buttons--desktop">
    @if (respondableNotification && !respondingToComment && !ppCommentSent && commentsEditable) {
      <div
        ppTooltip
        [ppTitle]="'respond' | ppTranslate"
        class="notification__respond-button"
        (click)="respond($event)"
        >
        <img
          class="notification__respond-image--grey notification__respond-button"
          [src]="EIconPath.NOTIFICATION_RESPOND"
          />
        <pp-icon
          class="notification__respond-image--blue notification__respond-button"
          [ppSrc]="EIconPath.NOTIFICATION_RESPOND_PRIMARY"
          ppColor="primary-950"
          ></pp-icon>
      </div>
    }

    @if (ppCommentSent && !respondingToComment) {
      <div
        ppTooltip
        ppTitle="Comment Sent"
        class="notification__sent-button"
        >
        <img class="notification__sent-button" [src]="EIconPath.NOTIFICATION_SENT_TICK" />
      </div>
    }

    @if (
      (ppNotification.pushNotificationType === ENotificationType.POINT_EDITION_COMMENT ||
      ppNotification.pushNotificationType === ENotificationType.POINT_MENTION_COMMENT) &&
      ppNotification.changeBody?.commentId
      ) {
      <div
        ppTooltip
      [ppTitle]="
        ppReaction?.like.includes(activeUser.userId)
          ? ('unlike_comment' | ppTranslate)
          : ('like_comment' | ppTranslate)
      "
        class="notification__like-comment-button"
        (click)="likeComment($event)"
        >
        @if (ppReaction?.like.includes(activeUser.userId)) {
          <pp-icon
            class="notification__like-comment-button-image"
            [ppSrc]="EIconPath.INTERACTION_LIKE_FILLED"
            ppColor="primary-950"
            ></pp-icon>
        }
        @if (!ppReaction?.like.includes(activeUser.userId)) {
          <pp-icon
            class="notification__like-comment-button-image"
            [ppSrc]="EIconPath.INTERACTION_LIKE"
            ppColor="inherit"
            ></pp-icon>
        }
      </div>
    }
  </div>
</div>
